module.exports = __webpack_public_path__ + "img/5.8e43a370.jpg";